import animation from "../../assets/lottie/unauthorized_lottie.json"; // percorso del tuo file
import Lottie from "lottie-react";
import React, {useEffect, useState} from "react";
import { NavLink } from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";

const Unauthorized = () => {
  const {customClaims} = useAuth();
  const [destination, setDestination] = useState<string>('/dashboard');

  useEffect(() => {
    if (customClaims?.grants) {
      customClaims?.grants.includes('lp_standalone') ? setDestination('/lp-list') : setDestination('/dashboard')
    }
  }, [customClaims]);

  return <div className="flex-col gap-2" style={{alignItems: "center"}}>
    <div style={{ width: 200, height: 200, margin: "auto" }}>
      <Lottie animationData={animation} loop={false} />
    </div>
    <h3>Non sei autorizzato ad accedere 🤨</h3>
    <NavLink to={destination}>Torna all'area di lavoro!</NavLink>
  </div>;
};

export default Unauthorized;
